import { render, staticRenderFns } from "./VideoDialog.vue?vue&type=template&id=63971d0f&scoped=true&"
import script from "./VideoDialog.vue?vue&type=script&lang=js&"
export * from "./VideoDialog.vue?vue&type=script&lang=js&"
import style0 from "./VideoDialog.vue?vue&type=style&index=0&id=63971d0f&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63971d0f",
  null
  
)

export default component.exports